<template>
  <div>
    <tokens-demand-list
      :value="demandList"
      :loading="loadingData"
      :search="search"
    />

    <!-- RouterView for modals -->
    <router-view />
  </div>
</template>

<script>
import Repositories from 'src/repositories'

import TokensDemandList from '../../token/components/TokensDemandList'

export default {
  name: 'CompanyDemandsContainer',
  components: {
    TokensDemandList,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
    search: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    demandList: [],
    loadingData: false,
  }),
  watch: {
    $route: {
      immediate: true,
      handler ({ name }) {
        if (name === 'CompanyDemands') {
          this.fetchData()
        }
      },
    },
  },
  methods: {
    async fetchData () {
      this.loadingData = true
      this.demandList = await Repositories.company.getTokensDemandList(this.companyId)
      this.loadingData = false
    },
  },
}
</script>
